import React, { Component } from 'react'

import { MuiTypography, MuiGrid, MuiDialogContent, MuiDialogActions, MuiDialogTitle, MuiButton, MuiDialog, MuiDivider, MuiDialogContentText, muiWithStyles } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'

export default class AlertDialogComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			errorMessage: undefined
		}

	}
	componentDidMount = () => {
		const i18n = this.props.i18n
		if (this.props.errorMessage === undefined) {
			this.setState({ errorMessage: i18n.teachers.confirmDelete })
		} else {
			this.setState({ errorMessage: this.props.errorMessage })
		}
	}
	render() {
		const { i18n } = this.props
		return (
			<MuiGrid>
				<MuiDialog
					id="dialog"
					open={this.props.openDialog}
					onClose={this.props.handleCloseDialog}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
					disableBackdropClick={true}
				>
					<MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
						<MuiGrid container>
							<MuiGrid item xs container alignItems="center" justify="center" >
								<MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
									Alert
                            </MuiTypography>
							</MuiGrid>
						</MuiGrid>
					</MuiDialogTitle>

					<MuiDialogContent>
						<MuiGrid container xs={12} alignContent="center" justify="center">
							<MuiTypography style={theme.typography.body2}>
								{this.state.errorMessage}</MuiTypography></MuiGrid>

					</MuiDialogContent>
					<MuiDialogActions>
						<MuiGrid container spacing={2} align="center" justify='flex-end'>

							<MuiGrid item >
								<MuiButton
									onClick={() => this.props.handleCloseDialog()}
									style={theme.secondaryButtonStyle}
								>
									{i18n.commonTexts.no}
								</MuiButton>
							</MuiGrid>
							<MuiGrid item  >
								<MuiButton

									style={theme.primaryButtonStyle}
									onClick={() => this.props.handleClickOnYes()}
									autoFocus
								>
									{i18n.commonTexts.yes}
								</MuiButton>
							</MuiGrid>
						</MuiGrid>
					</MuiDialogActions>
				</MuiDialog>
			</MuiGrid>
		);
	}
}
